import React from 'react';
import versionData from '../version.json';

const VersionBadge = () => {
  const buildDate = new Date(versionData.buildTime);

  // UTC format: "26-03-17 20:04:24 UTC"
  const utcFormatted = buildDate.toISOString()
    .replace('T', ' ')
    .replace(/\.\d{3}Z$/, '')
    .slice(2); // Remove century (20)

  // Local time with timezone
  const localOptions = {
    hour: 'numeric',
    minute: '2-digit',
    timeZoneName: 'short'
  };
  const localFormatted = buildDate.toLocaleString(undefined, localOptions);

  return (
    <div className="fixed top-1 left-1/2 -translate-x-1/2 z-[60] text-[10px] text-white/70 whitespace-nowrap pointer-events-none">
      <span>Founding Member Preview · {utcFormatted} UTC ({localFormatted})</span>
    </div>
  );
};

export default VersionBadge;
